import { render, staticRenderFns } from "./courseList_new.vue?vue&type=template&id=4c999acd&scoped=true"
import script from "./courseList_new.vue?vue&type=script&lang=js"
export * from "./courseList_new.vue?vue&type=script&lang=js"
import style0 from "./courseList_new.vue?vue&type=style&index=0&id=4c999acd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c999acd",
  null
  
)

export default component.exports